module.exports = __webpack_public_path__ + "img/catalog.ebc46b78.svg";